import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ProductionFilter from './production-filter';
import ProductionTable from './production-table';
import ProductionTile from './production-tile';
import ProductionSearch from './production-search';
import { selectProductionFilterVisible, selectTileView } from './store/selectors'; // Import the selector

const ProductionContent = props => {
  const isFilterVisible = useSelector(selectProductionFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <ProductionSearch />
        </div>
        {isFilterVisible && <ProductionFilter />}

        {!showTileView ? <ProductionTable /> : <ProductionTile />}
      </div>
    </div>
  );
};

export default ProductionContent;
